import { ref, watch } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
import { useRouter } from 'vue-router';
import Cookies from 'js-cookie';

export function useAuth() {
    const authStore = useAuthStore();
    const router    = useRouter();

    // Cookie es la fuente de verdad; si expiró, ignorar el estado persistido en localStorage
    const isAuthenticated = ref(authStore.isAuthenticated && !!Cookies.get('isAuthenticated'));
    const type_user       = ref(authStore.type_user);

    watch(() => authStore.isAuthenticated, (val) => isAuthenticated.value = val);
    watch(() => authStore.type_user,       (val) => type_user.value = val);

    const logout = async () => {
        await authStore.logout();
        router.replace('/');
    };

    return { isAuthenticated, type_user, logout, authStore };
}